import { render } from "./InitialCapitalTable.vue?vue&type=template&id=6e71572e"
import script from "./InitialCapitalTable.vue?vue&type=script&lang=js"
export * from "./InitialCapitalTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/artur/code/vue/zinzeszinsapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__